// extracted by mini-css-extract-plugin
module.exports = {"yellow":"#ebff0c"};